import { __decorate } from '../../../../node_modules/tslib/tslib.es6.mjs.js';
import '../../../../node_modules/lit/node_modules/@lit/reactive-element/reactive-element.js';
import { html as x } from '../../../../node_modules/lit-html/lit-html.js';
import { LitElement as s } from '../../../../node_modules/lit-element/lit-element.js';
import { customElement as e } from '../../../../node_modules/lit/node_modules/@lit/reactive-element/decorators/custom-element.js';
import { property as n } from '../../../../node_modules/lit/node_modules/@lit/reactive-element/decorators/property.js';
import { state as t } from '../../../../node_modules/lit/node_modules/@lit/reactive-element/decorators/state.js';
import '../../../../node_modules/lit/node_modules/@lit/reactive-element/decorators/query-assigned-elements.js';
import { classMap as o } from '../../../../node_modules/lit-html/directives/class-map.js';
import { CarouselBase } from '../../lit-mixins/carousel-base/index.js';
import { onSlideChange } from '../../molecules/carousel-navigation/index.js';
import css_248z from './infographic.scss.js';
import '../../atoms/buttons/enums.js';
import { isRTL } from '../../utilities/dom-helpers/index.js';
import '../../atoms/buttons/icon-button/index.js';
import { getInfographicsSettings } from './settings/index.js';
import { renderInfographicLayout } from './layout/index.js';

const componentName = 'cvt-infographic';
let Infographic = class Infographic extends CarouselBase(s) {
    constructor() {
        super();
        this.divider = false;
        this.navTemplate = '';
        this.query = '(max-width: 1365px)';
        this.isMobile = false;
        this.swiperInstance = null;
        this.componentName = componentName;
    }
    firstUpdated() {
        setTimeout(() => {
            var _a;
            this.transformSlotsIntoSlides();
            this.initCarousel(getInfographicsSettings);
            this.swiperInstance = this.shadowRoot.querySelector('.swiper');
            if (this.isMobile) {
                this.swiperInstance.swiper.destroy(false, true);
            }
            const nav = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector('carousel-navigation');
            this._prevBtn = nav.shadowRoot.querySelector('.swiper-button-prev');
            this._nextBtn = nav.shadowRoot.querySelector('.swiper-button-next');
            this._counter =
                nav.shadowRoot.querySelector('.swiper-counter');
        }, 0);
    }
    updated() {
        if (!this.swiperInstance)
            return;
        if (!this.isMobile) {
            this.initCarousel(getInfographicsSettings).on('slideChange', () => onSlideChange(this._prevBtn, this._nextBtn));
            onSlideChange(this._prevBtn, this._nextBtn);
        }
        else {
            this.swiperInstance.swiper.destroy(false, true);
        }
    }
    _handleMediaQuery(event) {
        this.isMobile = event.detail.value;
    }
    render() {
        // Center slides on desktop if there is nothing to be scrolled
        // Number of slides shown is located in settings/index files
        const containerName = {
            rtl: this.rtl || isRTL(),
            divider: this.divider,
            'hide-nav': this.numberOfSlots < 5,
            'infographic-container-centered': this.numberOfSlots <= 3 || false,
            grey: this.colorschema === 'grey',
            burgundy: this.colorschema === 'burgundy',
        };
        return this.renderCarousel(x `<div class="infographic-container ${o(containerName)}">${renderInfographicLayout(this)}</div><lit-media-query .query="${this.query}" @changed="${this._handleMediaQuery}"></lit-media-query>`);
    }
};
Infographic.styles = [css_248z];
__decorate([
    n({ type: Boolean })
], Infographic.prototype, "divider", void 0);
__decorate([
    n({ type: String })
], Infographic.prototype, "navTemplate", void 0);
__decorate([
    t()
], Infographic.prototype, "query", void 0);
__decorate([
    t()
], Infographic.prototype, "isMobile", void 0);
__decorate([
    t()
], Infographic.prototype, "swiperInstance", void 0);
Infographic = __decorate([
    e(componentName)
], Infographic);

export { Infographic };
